import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "navbar navbar-expand navbar-light",
  style: {"background-color":"#f7d147"}
}
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = {
  class: "collapse navbar-collapse text-white",
  id: "navbarSupportedContent"
}
const _hoisted_4 = { class: "navbar-nav me-auto mb-2 mb-lg-0" }
const _hoisted_5 = { class: "nav-item active" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Legosæt")
const _hoisted_7 = { class: "nav-item active" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Klodser")
const _hoisted_9 = { class: "nav-item active" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Minifigurer")
const _hoisted_11 = { class: "d-flex" }

import { useAuth0 } from "@auth0/auth0-vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { logout, isAuthenticated } = useAuth0();

const logud = () => {
  localStorage.removeItem("accesstoken");
  logout({ returnTo: window.location.origin });
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("ul", _hoisted_4, [
            _createElementVNode("li", _hoisted_5, [
              _createVNode(_component_router_link, {
                to: "/",
                class: "nav-link"
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_7, [
              _createVNode(_component_router_link, {
                to: "/parts",
                class: "nav-link"
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_9, [
              _createVNode(_component_router_link, {
                to: "/minifigs",
                class: "nav-link"
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("a", {
              onClick: logud,
              class: "nav-item nav-link"
            }, [
              _createVNode(_component_font_awesome_icon, { icon: ['fas', 'right-from-bracket'] })
            ])
          ])
        ])
      ])
    ], 512), [
      [_vShow, _unref(isAuthenticated)]
    ]),
    _createVNode(_component_router_view)
  ], 64))
}
}

})